<template>
  <section>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
        <ul>
          <li class="formList">
            <dl>
              <dd>
                <v-select :items="duesTypeItems" item-value="value" item-text="text" v-model="param.searchType"
                          dense
                          clearable
                          flat
                          outlined
                          label="항목"
                          v-on:change="search"/>
              </dd>
            </dl>
            <dl>
              <dd>
                <date-range-component v-on:event="getSearchDate" label="납부일"
                                      :value="searchDate"></date-range-component>
              </dd>
              <dd>
                <div class="monthBx">
                  <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                          :class="{ active: month === activeItem}"
                          @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                  </button>
                </div>
              </dd>
            </dl>
            <dl>
              <dd>
                <v-switch
                    v-model="param.containDeleted"
                    flat
                    color="primary"
                    :label="param.containDeleted ? '삭제 내역 포함' : '삭제 내역 제외'"
                    @change="search"
                ></v-switch>
              </dd>
            </dl>

          </li>
        </ul>
      </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
<!--          <v-checkbox class="mgr" label="" v-model="all" :true-value="true" :false-value="false"/>-->
<!--          검색 된 총 <span class="txtPoint">{{ totalItems }}건</span> 선택-->
        </p>
        <div class="tableBtn">
          <ul>
<!--            <li class="tableBtnList">-->
<!--              <v-btn color="grey" depressed dark @click="deleteDues()">삭제</v-btn>-->
<!--            </li>-->
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" color="#666" dark @click="createForm()">납부내역 등록</v-btn>
            </li>
          </ul>
        </div>
      </div>

      <v-dialog v-model="dialogVisible" max-width="500px" @click:outside="dialogVisible = false" @keydown.esc="dialogVisible = false">
        <v-card>
          <v-card-title>
            <span class="headline">{{ duesTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>

              <v-form ref="formDues" @submit.prevent="">
                <v-row>
                  <v-col class="wh300">
                    <v-menu
                        v-model="cal"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dues.payDt"
                            label="납부일"
                            prepend-icon="mdi-calendar"
                            readonly
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            :rules="[rules.required]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dues.payDt"
                          @input="cal = false"
                          locale="ko"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="wh300">
                    <v-select :items="duesTypeItems" item-value="value" item-text="text" v-model="dues.duesType"
                              clearable required
                              :rules="[rules.required]" label="항목" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="wh300 d-flex">
                    <v-text-field v-model="dues.amount" type="number" :rules="[rules.required]" label="금액" :readonly="activeAmount!==0"></v-text-field>
                    <div class="amountBx">
                      <button type="button" class="btn amount" v-for="(amt, idx) in amountItems"
                              :class="{ active: amt.value === activeAmount}"
                              @click="selectAmount(amt.value)" :key="idx">{{ amt.text }}
                      </button>
                    </div>
                  </v-col>
                </v-row>

              </v-form>

            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" dark @click="dialogVisible = false">취소</v-btn>
            <v-btn color="primary" dark @click="saveDues">저장</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="dataset"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="duesId"
            class="elevation-1"
            :single-expand="true"
            :expanded.sync="expanded"
            @item-expanded="duesHistories"
            show-expand
            disable-sort
        >
          <template v-slot:item.idx="{item}">
            {{item.idx}}
          </template>
          <template v-slot:item.duesType="{item}">
            <template v-for="(t, index) in duesTypeItems">
              <span v-if="t.value === item.duesType" :key="index"
                    :class="item.deleted ? 'text-decoration-line-through' : ''"
              > {{t.text}} </span>
            </template>
          </template>
          <template v-slot:item.amount="{item, value}">
            <span :class="item.deleted ? 'text-decoration-line-through' : ''">
              {{ value | numeralFormat('0,000')}}
            </span>
          </template>

          <template v-slot:item.payDt="{ item, value }">
            <span :class="item.deleted ? 'text-decoration-line-through' : ''">
              {{ value | moment('YYYY-MM-DD') }}
            </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                class="mr-2"
                @click.stop="updateForm(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                @click.stop="deleteDues(item)"
                v-if="!item.deleted"
            >
              mdi-delete
            </v-icon>
<!--            <v-btn class="vBtn vIconResize mgr" @click="recoverDues(item)" color="#666" dark v-if="item.deleted">-->
              <v-icon
                  @click="recoverDues(item)"
                  v-if="item.deleted"
              >
                mdi-reload
              </v-icon>
<!--              복구-->
<!--            </v-btn>-->
          </template>

          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers.length" style="padding: 20px 20px 20px 20px">

              <v-card>

                <v-data-table
                    :headers="detailHeaders"
                    :items="histories"
                    :footer-props="{showFirstLastPage: true}"
                    class="elevation-1"
                >
<!--                  <template v-slot:item.idx="props">-->
<!--                    {{histories.length - (props.index)}}-->
<!--                  </template>-->
                  <template v-slot:item.duesType="{value}">
                    <template v-for="(t, index) in duesTypeItems">
                      <span v-if="t.value === value" :key="index"> {{t.text}} </span>
                    </template>
                  </template>
                  <template v-slot:item.amount="{value}">
                    {{ value | numeralFormat('0,000')}}
                  </template>
                  <template v-slot:item.changeType="{ value }">
                    {{ value === 'UPDATE' ? '수정' : '삭제' }}
                  </template>
                  <template v-slot:item.changedAt="{ value }">
                    {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
                  </template>

<!--                  <template v-slot:detailItem.actions="detailItem">-->
<!--                    <v-icon-->
<!--                        small-->
<!--                        @click.stop="deleteDetail(detailItem)"-->
<!--                    >-->
<!--                      mdi-delete-->
<!--                    </v-icon>-->
<!--                  </template>-->
                </v-data-table>

              </v-card>
            </td>
          </template>

        </v-data-table>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent"
import duesApi from '@/api/DuesApi'
import _ from "lodash"

export default {
  name: "DuesList",
  components: {
    'date-range-component': DateRageComponent
  },
  props: {
    userId: String
  },
  data: () => ({
    expanded: [],
    detailHeaders: [
      // {text: '일련번호', value: 'idx', sortable: false},
      {text: '항목', value: 'duesType'},
      {text: '금액', value: 'amount'},
      {text: '납부일', value: 'payDt'},
      {text: '이력타입', value: 'changeType'},
      {text: '수정일', value: 'changedAt'},
      {text: '수정자', value: 'changedBy'},
      // {text: '관리', value: 'actions', sortable: false}
    ],
    histories: [],
    date: new Date(),
    menu: false,
    menu2: false,
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    selected: [],
    headers: [
      {text: 'No', value: 'idx'},
      {text: '항목', value: 'duesType'},
      {text: '금액', value: 'amount'},
      {text: '납부일', value: 'payDt'},
      {text: '관리', value: 'actions'},
      {text: '내역', value: 'data-table-expand'}
    ],
    param: {
      fromJoin: null,
      toJoin: null,
      page: 1
    },
    options:{},
    dataset: [],
    totalItems: 0,
    searchDate: [],
    dialogVisible: false,
    waitingSearch: false,
    searchValue: null,
    duesTypeItems: [
      {value:'TYPE_DUES_ECLUB', text:'전자사랑 연회비'},
      {value:'TYPE_DUES_DEPARTMENT_YEAR', text:'분과 연회비'},
      {value:'TYPE_DUES_DEPARTMENT_MEETING', text:'분과 모임비'},
      {value:'TYPE_DUES_CLUB_YEAR', text:'동호회 연회비'},
      {value:'TYPE_DUES_CLUB_MEETING', text:'동호회 모임비'}
    ],
    dues:{},
    rules: {
      required: value => !!(value || value === false || value === true) || '필수 입력 항목입니다..'
    },
    duesTitle:'',
    all: false,
    amountItems: [
      {value: 10000, text: '1만'}, {value: 30000, text: '3만'}, {value: 50000, text: '5만'},
      {value: 100000, text: '10만'}, {value: 0, text: '직접입력'}],
    activeAmount:0,
    cal: false,
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    }
  },
  methods: {
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      this.search();
    },
    selectItem(months) {
      this.activeItem = months;
      this.searchDate = [];
      if (this.activeItem !== 0) {
        this.searchDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    search() {
      const {  page, itemsPerPage, size } = this.options;
      const params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if (this.activeItem > 0) {
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      params.userId = this.userId;

      duesApi.list(params).then(data => {
        this.totalItems = data.totalElements;
        this.dataset = data.content.map((d, i) => {
          d.idx = this.totalItems - i - (( (data.pageable.offset+1) - 1) * data.pageable.pageSize);
          return d;
        });
        // console.log(data);
      });
    },
    duesHistories({item, value}) {
      if(value) {
        duesApi.histories(item.duesId).then(data => {
          this.histories = data;
        });
      } else {
        this.histories = [];
      }
    },
    createForm() {
      this.dues = {};
      this.$refs.formDues?.resetValidation();
      this.dialogVisible = true;
      this.duesTitle = '납부 내역 추가';
      this.activeAmount = 0;
    },
    updateForm(dues) {
      this.dues = _.cloneDeep(dues);
      this.dialogVisible = true;
      this.duesTitle = '납부 내역 수정';
      this.activeAmount = 0;
    },
    deleteDues(dues) {
      if(confirm("삭제하시겠습니까?")) {
        duesApi.delete(dues.duesId).then(() => {
          this.search();
          this.duesHistories({item: {duesId: dues.duesId}, value: true});
        });
      }
    },
    recoverDues(dues) {
      if(confirm("복구하시겠습니까?")) {
        duesApi.recover(dues.duesId).then(() => {
          this.search();
          this.duesHistories({item: {duesId: dues.duesId}, value: true});
        });
      }
    },
    async saveDues() {
      if(!await this.$refs.formDues.validate()) {
        return
      }

      this.dues.userId = this.userId;
      duesApi.save(this.dues).then(() => {
        this.search();
        if(this.dues.duesId) {
          this.duesHistories({item: {duesId: this.dues.duesId}, value: true});
        }
        this.dialogVisible = false;
      });
    },
    selectAmount(amt) {
      this.activeAmount = amt;
      if(amt === 0)
        this.$refs.formDues?.resetValidation();

      this.dues.amount = amt;
    }
  },
  created: function () {
    this.search();
  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    //width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
.amountBx {
  display: flex;
  align-items: center;
  height: 35px;
  border-radius: 3px;
  border: 1px solid #1867c0;
  margin-top: 13px;

  .amount {
    &:first-child {
      padding-left: 10px;
    }

    height: 100%;
    padding: 0 8px;
    border: 0;
    background: #fff;
    font-size: 13px;
    font-weight: normal;
    color: #1867c0;

    &.active {
      background: #1867c0;
      color: #fff;
    }
  }
}
</style>